import styles from './DevicesMenu.module.scss';

import React, { FC } from 'react';

import { ContentLinkV2 } from 'components/ContentLinkV2/ContentLinkV2';
import { DevicesMenuItem } from 'api/contentful/contentTypes.cloverdotcom';
import { FlatResponsiveImage } from 'components/FlatResponsiveImage/FlatResponsiveImage';
import { TextV2 } from 'components/TextV2/TextV2';
import { FlatEntry } from 'services/cms/flattenContentful';
import { AppType, toEntry, toSysId } from 'services/cms/typesUtil';
import { FadeToastUp } from 'components/Animation/FadeToastUp/FadeToastUp';

type DevicesMenuProps = AppType.Component<FlatEntry<DevicesMenuItem>>;

export const DevicesMenu: FC<DevicesMenuProps> = ({ items: initialItems = [], _attributes }) => {
  const items = initialItems.filter(Boolean);
  if (!items.length) return null;

  return (
    <section className={styles.devicesMenu} {..._attributes}>
      <FadeToastUp>
        <nav>
          <ul>
            {items.map(device => (
              <li key={toSysId(device)}>
                {device.link && (
                  <>
                    <FlatResponsiveImage image={device.image} alt={device.title} className={styles.image} />
                    <ContentLinkV2 entry={toEntry(device.link)} hideTitle className={styles.link}>
                      <TextV2
                        value={device.title}
                        tagName="span"
                        variant="modern-body"
                        className={styles.title}
                      />
                    </ContentLinkV2>
                  </>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </FadeToastUp>
    </section>
  );
};
